import { Navigate, useLocation } from "react-router-dom";
import { MEMBER_ELECTIONS_PENDING_PATH } from "../membership-services/member-elections/constants";

export default function LegacyMemberElectionsRedirect() {
  const location = useLocation();
  return <Navigate to={`${MEMBER_ELECTIONS_PENDING_PATH}${location.search}`} replace />;
}
